<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Hébergements localisés</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'locationRentingCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter un hébergement localisé
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <div class="clear"></div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Nom
              </th>
              <th class="text-center text-uppercase">
                Page hébergement
              </th>
              <th class="text-center text-uppercase">
                Etat
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(renting, rentingIndex) in rentings"
              :key="'e' + rentingIndex"
            >
              <td class="font-weight-bold">
                {{ resolveAttrValue(renting, 'name') }}
              </td>
              <td class="text-center">
                <span v-if="renting.renting">
                  {{ renting.renting.translations.fr.name }}
                </span>
              </td>
              <td class="text-center">
                <v-chip
                  v-if="renting.enabled"
                  color="success"
                  text-color="white"
                  small
                >
                  Activé
                </v-chip>
                <v-chip
                  v-if="!renting.enabled"
                  color="error"
                  text-color="white"
                  small
                >
                  Désactivé
                </v-chip>
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'locationRentingDetails', params: { locationRentingId: renting.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteRentingDialog(renting)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!rentings.length">
            <tr>
              <td>
                <span v-if="loading === false">Aucun éléments.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteRentingDialog
        :key="Date.now()"
        :delete-renting-dialog-state="deleteRentingDialogState"
        :renting="rentingToDelete"
        @closeDeleteRentingDialog="closeDeleteRentingDialog($event)"
      ></DeleteRentingDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPlay, mdiPen, mdiEye, mdiTrashCan } from '@mdi/js'
import Vue from 'vue'
import DeleteRentingDialog from '@/components/Dialog/LocationDialog/Renting/DeleteRentingDialog'
import config from '../../../config'
import Loader from '@/components/Common/Loader'

export default {
  components: {
    DeleteRentingDialog,
    Loader
  },
  data: () => ({
    rentings: [],
    rentingToDelete: null,
    deleteRentingDialogState: false,
    loading: false,
    icons: {
      mdiPlay,
      mdiPen,
      mdiEye,
      mdiTrashCan
    }
  }),
  created () {
    this.getRentings()
  },
  methods: {
    getRentings () {
      this.loading = true

      const params = {
        limit: 150
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/location/rentings', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const data = response.data

            if (data) {
              this.rentings = data
            }
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    openDeleteRentingDialog (renting) {
      this.deleteRentingDialogState = true
      this.rentingToDelete = renting
    },
    closeDeleteRentingDialog (deleteState) {
      if (deleteState === true) {
        this.rentings = this.rentings.filter(element => element.id !== this.rentingToDelete.id)
      }

      this.deleteRentingDialogState = false
    },
    resolveAttrValue (data, attr) {
      const translations = data.translations

      if (translations.fr) {
        return translations.fr[attr]
      }

      return '-'
    }
  }
}
</script>

